const LogoFooter = (props: React.ImgHTMLAttributes<HTMLImageElement>) => (
  <img
    src="/logo-footer.svg"
    
    height={28}
    {...props}
  />
);

export default LogoFooter;
